import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;

import { observable, runInAction, makeObservable, computed } from "mobx";
import * as yup from "yup";
import { getMaxDobDate, isEmailValid as isEmailAddressValid, isPhoneNumberValid, normalizePhoneNumber } from "@dp/common";
import moment from "moment";
import { persist } from "mobx-persist";
var phoneRegExp = /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s-]?[\0-9]{3}[\s-]?[0-9]{4}$/;

var _SCHEMA = yup.object({
  fName: yup.string().required("Please enter first name"),
  lName: yup.string().required("Please enter last name").min(2, "Must be minimum 2 characters"),
  emailId: yup.string().required("Please enter email").email("Please enter valid email"),
  phoneNumber: yup.string().when(["phoneNumberVisible"], {
    is: true,
    then: yup.string().required("Please enter phone number").matches(phoneRegExp, "Phone number is not valid"),
    otherwise: yup.string().nullable()
  }),
  isDOBErrorValid: yup["boolean"](),
  eclubeDate: yup.string().when("isDOBErrorValid", {
    is: true,
    then: yup.string().required("Please select date")
  }),
  eclubeMonth: yup.string().when("isDOBErrorValid", {
    is: true,
    then: yup.string().required("Please select month")
  }),
  eclubeYear: yup.string().when("isDOBErrorValid", {
    is: true,
    then: yup.string().required("Please select year")
  })
});

var ContactInfoModel = (_class = /*#__PURE__*/function () {
  function ContactInfoModel(platformUtil) {
    var _this = this;

    _classCallCheck(this, ContactInfoModel);

    _initializerDefineProperty(this, "_fName", _descriptor, this);

    _initializerDefineProperty(this, "_lName", _descriptor2, this);

    _initializerDefineProperty(this, "_emailId", _descriptor3, this);

    _initializerDefineProperty(this, "_phoneNumber", _descriptor4, this);

    _initializerDefineProperty(this, "_phoneNumberVisible", _descriptor5, this);

    _initializerDefineProperty(this, "_splOffer", _descriptor6, this);

    _initializerDefineProperty(this, "_eclubeDate", _descriptor7, this);

    _initializerDefineProperty(this, "_eclubeMonth", _descriptor8, this);

    _initializerDefineProperty(this, "_eclubeYear", _descriptor9, this);

    _initializerDefineProperty(this, "_isSmartPaySelected", _descriptor10, this);

    _initializerDefineProperty(this, "_componentRef", _descriptor11, this);

    _initializerDefineProperty(this, "_appAttributes", _descriptor12, this);

    _initializerDefineProperty(this, "_errorsYPosition", _descriptor13, this);

    _initializerDefineProperty(this, "_showFormError", _descriptor14, this);

    _initializerDefineProperty(this, "_isApplePaySelected", _descriptor15, this);

    _defineProperty(this, "platformUtil", void 0);

    _defineProperty(this, "setErrorsYPosition", function (key, yPosition) {
      runInAction(function () {
        _this._errorsYPosition[key] = yPosition;
      });
    });

    this.platformUtil = platformUtil;
    this.eclubeDate = "";
    this.eclubeMonth = "";
    this.eclubeYear = "";
    this._splOffer = true;
    makeObservable(this);
  }

  _createClass(ContactInfoModel, [{
    key: "setAppAttributes",
    value: function setAppAttributes(_appAttributes) {
      var _this2 = this;

      runInAction(function () {
        _this2._appAttributes = _appAttributes;
      });
    }
  }, {
    key: "handleInvalidModel",
    value: function handleInvalidModel(appMessages) {
      var _this3 = this;

      var isMobile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      appMessages.showError("Missing Details.", "Please enter all highlighted fields.", null, {
        okBtnText: "OK",
        okBtnOnClick: function okBtnOnClick() {
          _this3.platformUtil.scrollToElement(_this3.componentRef, isMobile ? 30 : 0);
        }
      });
      this.platformUtil.dispatchEvent("AnalyticsEvent", "DisplayModal", {
        modalIntent: "Error modal for contact details missing",
        modalContent: "Error modal for contact details missing",
        modalName: "ContactInfo-Error-Modal"
      });
    }
  }, {
    key: "validateEclubDate",
    value: function validateEclubDate() {
      if (!this.calendarDays.includes(parseInt(this.eclubeDate))) {
        this.eclubeDate = "";
      }
    }
  }, {
    key: "fName",
    get: function get() {
      return this._fName;
    },
    set: function set(val) {
      var _this4 = this;

      runInAction(function () {
        _this4._fName = val;
      });
    }
  }, {
    key: "lName",
    get: function get() {
      return this._lName;
    },
    set: function set(val) {
      var _this5 = this;

      runInAction(function () {
        _this5._lName = val;
      });
    }
  }, {
    key: "emailId",
    get: function get() {
      return this._emailId;
    },
    set: function set(val) {
      var _this6 = this;

      runInAction(function () {
        _this6._emailId = val;
      });
    }
  }, {
    key: "phoneNumber",
    get: function get() {
      return this._phoneNumber;
    },
    set: function set(value) {
      var _this7 = this;

      var newNumber = normalizePhoneNumber(value, this._phoneNumber);
      runInAction(function () {
        _this7._phoneNumber = newNumber;
      });
    }
  }, {
    key: "splOffer",
    get: function get() {
      return this._splOffer;
    },
    set: function set(val) {
      var _this8 = this;

      runInAction(function () {
        _this8._splOffer = val;
      });
    }
  }, {
    key: "eclubeDate",
    get: function get() {
      return this._eclubeDate;
    },
    set: function set(_eclubeDate) {
      var _this9 = this;

      runInAction(function () {
        _this9._eclubeDate = _eclubeDate;
      });
    }
  }, {
    key: "eclubeMonth",
    get: function get() {
      return this._eclubeMonth;
    },
    set: function set(_eclubeMonth) {
      var _this10 = this;

      runInAction(function () {
        _this10._eclubeMonth = _eclubeMonth;
      });
    }
  }, {
    key: "eclubeYear",
    get: function get() {
      return this._eclubeYear;
    },
    set: function set(_eclubeYear) {
      var _this11 = this;

      runInAction(function () {
        _this11._eclubeYear = _eclubeYear;
      });
    }
  }, {
    key: "componentRef",
    get: function get() {
      return this._componentRef;
    },
    set: function set(_componentRef) {
      var _this12 = this;

      runInAction(function () {
        _this12._componentRef = _componentRef;
      });
    }
  }, {
    key: "errors",
    get: function get() {
      var errObj = {};

      try {
        _SCHEMA.validateSync(this, {
          abortEarly: false
        });
      } catch (e) {
        var error = e;
        error.inner.forEach(function (err) {
          errObj[err.params.path] = err.message;
        });
      }

      return errObj;
    }
  }, {
    key: "maxDobYear",
    get: function get() {
      return getMaxDobDate().year;
    }
  }, {
    key: "maxDobMonth",
    get: function get() {
      return getMaxDobDate().month;
    }
  }, {
    key: "maxDobDate",
    get: function get() {
      return getMaxDobDate().date;
    }
  }, {
    key: "errorsYPosition",
    get: function get() {
      return this._errorsYPosition;
    }
  }, {
    key: "calendarDays",
    get: function get() {
      var defaultValue = [];

      if (this.eclubeMonth && this.eclubeYear) {
        // const month = moment().month(this._eclubeMonth).format("M");
        var year = this.eclubeYear;
        var monthIndex = parseInt("".concat(this._eclubeMonth)); // 0..11 instead of 1..12
        // monthIndex = monthIndex === 0 ? 1 : monthIndex;
        // const date = new Date(parseInt(year), monthIndex, 1);

        var date = moment().year(parseInt(year)).month(monthIndex - 1).date(1).toDate();
        var result = [];

        while (date.getMonth() === monthIndex - 1) {
          result.push(date.getDate());
          date.setDate(date.getDate() + 1);

          if (parseInt(this.eclubeYear) === this.maxDobYear && monthIndex === this.maxDobMonth && date.getDate() > this.maxDobDate) {
            break;
          }
        }

        return result;
      }

      return defaultValue;
    }
  }, {
    key: "isFirstNameValid",
    get: function get() {
      return !!this._fName;
    }
  }, {
    key: "isLastNameValid",
    get: function get() {
      return !!this._lName && this._lName.length >= 2;
    }
  }, {
    key: "isEmailValid",
    get: function get() {
      return this._emailId && isEmailAddressValid(this._emailId) && !this.errors["emailId"];
    }
  }, {
    key: "isPhoneValid",
    get: function get() {
      if (this._phoneNumberVisible) return isPhoneNumberValid(this.phoneNumber);else return true;
    }
  }, {
    key: "phoneNumberVisible",
    get: function get() {
      return this._phoneNumberVisible;
    },
    set: function set(_phoneNumberVisible) {
      var _this13 = this;

      runInAction(function () {
        _this13._phoneNumberVisible = _phoneNumberVisible;
      });
    }
  }, {
    key: "showFormError",
    get: function get() {
      return this._showFormError;
    },
    set: function set(_showFormError) {
      var _this14 = this;

      runInAction(function () {
        _this14._showFormError = _showFormError;
      });
    }
  }, {
    key: "isValid",
    get: function get() {
      if (this.isSmartPaySelected && !this.isApplePaySelected) {
        if (this.isDOBErrorValid) return this.isDOBValid;
        return true;
      } else {
        if (this.isDOBErrorValid) return this.isDOBValid && this.isContactInfoValid;
        return this.isContactInfoValid;
      }
    }
  }, {
    key: "isDOBErrorValid",
    get: function get() {
      return this.enableSpecialOffers && this.splOffer && this.isDOBMandatory && (this.isMonthValid || this.isDateValid || this.isYearValid);
    }
  }, {
    key: "isDOBMandatory",
    get: function get() {
      var _this$_appAttributes;

      return (_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : _this$_appAttributes.dOBMandatoryonSignup;
    }
  }, {
    key: "isDateValid",
    get: function get() {
      return !!this.eclubeDate;
    }
  }, {
    key: "isMonthValid",
    get: function get() {
      return !!this.eclubeMonth;
    }
  }, {
    key: "isYearValid",
    get: function get() {
      return !!this.eclubeYear;
    }
  }, {
    key: "isDOBValid",
    get: function get() {
      return this.isDateValid && this.isMonthValid && this.isYearValid;
    }
  }, {
    key: "isContactInfoValid",
    get: function get() {
      return this.isFirstNameValid && this.isLastNameValid && this.isEmailValid && this.isPhoneValid;
    }
  }, {
    key: "isSmartPaySelected",
    get: function get() {
      return this._isSmartPaySelected;
    },
    set: function set(val) {
      var _this15 = this;

      runInAction(function () {
        _this15._isSmartPaySelected = val;
      });
    }
  }, {
    key: "generateYears",
    get: function get() {
      var emptyYear = [];
      var yearList = [];
      var maxYear = this.maxDobYear;

      if (this._appAttributes) {
        var _this$_appAttributes2 = this._appAttributes,
            startYear = _this$_appAttributes2.startYear,
            endYear = _this$_appAttributes2.endYear;
        var lastYear = endYear > maxYear ? maxYear : endYear;
        var totalNoOfYear = lastYear - startYear;

        for (var i = 0; i <= totalNoOfYear; i++) {
          yearList.push(startYear + i);
        }

        return yearList;
      }

      return emptyYear;
    }
  }, {
    key: "generatedMonths",
    get: function get() {
      var monthList = moment.months();

      if (parseInt(this._eclubeYear) === this.maxDobYear) {
        return monthList.slice(0, this.maxDobMonth);
      }

      return monthList;
    }
  }, {
    key: "enableSpecialOffers",
    get: function get() {
      var _this$_appAttributes3, _this$_appAttributes4, _this$_appAttributes5, _this$_appAttributes6;

      return (this === null || this === void 0 ? void 0 : (_this$_appAttributes3 = this._appAttributes) === null || _this$_appAttributes3 === void 0 ? void 0 : (_this$_appAttributes4 = _this$_appAttributes3.configs) === null || _this$_appAttributes4 === void 0 ? void 0 : _this$_appAttributes4.onlineorder_enable_crm_precheck) && (this === null || this === void 0 ? void 0 : (_this$_appAttributes5 = this._appAttributes) === null || _this$_appAttributes5 === void 0 ? void 0 : (_this$_appAttributes6 = _this$_appAttributes5.configs) === null || _this$_appAttributes6 === void 0 ? void 0 : _this$_appAttributes6.onlineorder_enable_crm_precheck) === "true";
    }
  }, {
    key: "showDOBFields",
    get: function get() {
      var _this$_appAttributes7;

      return (_this$_appAttributes7 = this._appAttributes) === null || _this$_appAttributes7 === void 0 ? void 0 : _this$_appAttributes7.dOBMandatoryonSignup;
    }
  }, {
    key: "firstNameMaxLength",
    get: function get() {
      var _this$_appAttributes8, _this$_appAttributes9;

      return (this === null || this === void 0 ? void 0 : (_this$_appAttributes8 = this._appAttributes) === null || _this$_appAttributes8 === void 0 ? void 0 : (_this$_appAttributes9 = _this$_appAttributes8.configs) === null || _this$_appAttributes9 === void 0 ? void 0 : _this$_appAttributes9.checkout_name_maxlength) || 32;
    }
  }, {
    key: "emailMaxLength",
    get: function get() {
      var _this$_appAttributes10, _this$_appAttributes11;

      return (this === null || this === void 0 ? void 0 : (_this$_appAttributes10 = this._appAttributes) === null || _this$_appAttributes10 === void 0 ? void 0 : (_this$_appAttributes11 = _this$_appAttributes10.configs) === null || _this$_appAttributes11 === void 0 ? void 0 : _this$_appAttributes11.email_maxlength) || 40;
    }
  }, {
    key: "isApplePaySelected",
    get: function get() {
      return this._isApplePaySelected;
    },
    set: function set(_isApplePaySelected) {
      var _this16 = this;

      runInAction(function () {
        _this16._isApplePaySelected = _isApplePaySelected;
      });
    }
  }]);

  return ContactInfoModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_fName", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_lName", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_emailId", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_phoneNumber", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_phoneNumberVisible", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_splOffer", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_eclubeDate", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_eclubeMonth", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_eclubeYear", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_isSmartPaySelected", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_componentRef", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_errorsYPosition", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_showFormError", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_isApplePaySelected", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "fName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "fName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "lName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "emailId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "emailId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "phoneNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "phoneNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "splOffer", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "splOffer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "eclubeDate", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "eclubeDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "eclubeMonth", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "eclubeMonth"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "eclubeYear", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "eclubeYear"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "componentRef", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "componentRef"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errors", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maxDobYear", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maxDobYear"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maxDobMonth", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maxDobMonth"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maxDobDate", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maxDobDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errorsYPosition", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errorsYPosition"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "calendarDays", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "calendarDays"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isFirstNameValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFirstNameValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLastNameValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLastNameValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isEmailValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isEmailValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPhoneValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPhoneValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "phoneNumberVisible", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "phoneNumberVisible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showFormError", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showFormError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDOBErrorValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDOBErrorValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDOBMandatory", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDOBMandatory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDateValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDateValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMonthValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMonthValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isYearValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isYearValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDOBValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDOBValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isContactInfoValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isContactInfoValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSmartPaySelected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSmartPaySelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "generateYears", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "generateYears"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "generatedMonths", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "generatedMonths"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enableSpecialOffers", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "enableSpecialOffers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showDOBFields", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showDOBFields"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "firstNameMaxLength", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "firstNameMaxLength"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "emailMaxLength", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "emailMaxLength"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isApplePaySelected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isApplePaySelected"), _class.prototype)), _class);
export { ContactInfoModel as default };